import * as actions from './actionTypes';
import { setLoading, setMessage } from './general';
import axios from '../../config/axiosInstance';

export const fetchHoursSetsSuccess = hoursSets => ({
    type: actions.FETCH_HOURSSETS_SUCCESS,
    hoursSets,
});

export const fetchHoursSets = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .get(`/workingDaySet`)
    .then((response) => {
      dispatch(fetchHoursSetsSuccess(response.data));
      dispatch(setLoading(false));
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject();
    });
};

// export const createHolidaySuccess = holiday => ({
//   type: actions.CREATE_HOLIDAY_SUCCESS,
//   holiday,
// });

// export const createHoliday = holiday => (dispatch) => {
//   dispatch(setLoading(true));
//   axios
//     .post('/holidaysCompany/lot', holiday)
//     .then((response) => {
//       dispatch(createHolidaySuccess(response.data));
//       dispatch(setLoading(false));
//       dispatch(setMessage('Feriado cadastrado com sucesso.'));
//     })
//     .catch((error) => {
//       dispatch(setLoading(false));
//       dispatch(setMessage(error));
//     });
// };

// export const deleteHolidaySuccess = id => ({
//   type: actions.DELETE_HOLIDAY_SUCCESS,
//   id,
// });

// export const deleteHoliday = id => (dispatch) => {
//   dispatch(setLoading(true));
//   axios
//     .delete(`/holidaysCompany/${id}`)
//     .then(() => {
//       dispatch(deleteHolidaySuccess(id));
//       dispatch(setLoading(false));
//       dispatch(setMessage('Feriado excluído com sucesso.'));
//     })
//     .catch((error) => {
//       dispatch(setLoading(false));
//       dispatch(setMessage(error));
//     });
// };
